import type { MenuItem } from "primevue/menuitem";
import { onMounted, onUnmounted, ref } from "vue";
import { type RouteLocationRaw } from "vue-router";

import AdminRoutes from "@/enums/routes/AdminRoutes";

export type RouterMenuItem = MenuItem & { route?: RouteLocationRaw };

export const home = ref<RouterMenuItem>({ icon: "pi pi-home", route: { name: AdminRoutes.DASHBOARD } });
export const currentMenuItems = ref<RouterMenuItem[]>([]);

export function useBreadcrumbs(menuItems: RouterMenuItem[]): void {
    onMounted(() => {
        currentMenuItems.value = menuItems;
    });

    onUnmounted(() => {
        currentMenuItems.value = [];
    });
}
